// extracted by mini-css-extract-plugin
export default {"template":"template-UuCQO","optionsContainer":"optionsContainer-d7Jj0","option":"option-msvHP"};